import { DashboardLayout } from '../shared/ui/DashboardLayout'
import { GroupList } from '../features/groups/ui/GroupList'
import { useGroupsController } from '../features/groups/state/useGroupsController'
import { useSourcesController } from '../features/sources/state/useSourcesController'
import { usePagesController } from '../features/pages/state/usePagesController'

import { GroupRowSkeleton } from '../features/groups/ui/GroupSkeleton'

export function GroupsPage() {
  const groupsController = useGroupsController()
  const sourcesController = useSourcesController()
  const pagesController = usePagesController()

  const availableSources = sourcesController.sources.map((a) => ({
    id: a.id,
    name: a.name,
  }))
  const availablePages = pagesController.pages.map((p) => ({
    id: p.id,
    name: p.name,
  }))

  const isLoading = sourcesController.isLoading

  return (
    <DashboardLayout title="Group Management">
      <div
        style={{
          padding: 'var(--spacing-xl)',
          maxWidth: 1000,
          margin: '0 auto',
          width: '100%',
        }}
      >
        {isLoading ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {[...Array(3)].map((_, i) => (
              <GroupRowSkeleton key={i} />
            ))}
          </div>
        ) : (
          <GroupList
            groups={groupsController.groups}
            availableSources={availableSources}
            availablePages={availablePages}
            onCreate={groupsController.createGroup}
            onUpdate={groupsController.updateGroup}
            onDelete={groupsController.deleteGroup}
          />
        )}
      </div>
    </DashboardLayout>
  )
}
